import { HttpClient, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {
  ENGAGEMENT_API_TOKEN,
  ListOrderType,
  ProductListExportToEmailRequest,
  ProductListExportToImageRequest,
  ProductListExportToPDFRequest,
  ProductListExportToSheetRequest,
} from '@epicuro-next/data/engagement/engagement-models';
import { PRODUCT_LIST_API_LINK_TOKEN } from '@epicuro-next/data/lists';
import { Observable } from 'rxjs';

import { mapSearchSortTypeByOrdinal } from '../../utils';
import { mapListOrderType } from '../../utils/map-list-order-type/map-list-order-type';

@Injectable()
export class ProductListExportApiService {
  private resource: string;

  constructor(
    private http: HttpClient,
    @Inject(ENGAGEMENT_API_TOKEN) private readonly engagamentBaseUrl: string,
    @Inject(PRODUCT_LIST_API_LINK_TOKEN)
    private readonly epicuroBaseUrl: string,
  ) {
    this.resource = `${this.engagamentBaseUrl}/productlist`;
  }

  public exportToEmail({
    productListId,
    payload,
  }: ProductListExportToEmailRequest) {
    return this.http.post<void>(
      `${this.resource}/${productListId}/export/email`,
      payload,
    );
  }

  public exportToEmailPreview({
    productListId,
    payload,
  }: ProductListExportToEmailRequest) {
    return this.http.post(
      `${this.resource}/${productListId}/export/previewemail`,
      payload,
      { responseType: 'text' },
    );
  }

  public exportToPdf({
    productListId,
    isShowWholeSalePrices,
    groupByCategory,
  }: ProductListExportToPDFRequest) {
    return this.http.get(
      `${
        this.resource
      }/${productListId}/export/pdf?showWholesalePrices=${isShowWholeSalePrices}&groupByCategory=${
        groupByCategory ?? false
      }`,
      { responseType: 'blob' },
    );
  }

  public exportToSheet({
    accountIds,
    productReferences,
    sortField,
    sortDirection,
    orderType,
  }: ProductListExportToSheetRequest): Observable<HttpResponse<Blob>> {
    const body = {
      accountIds,
      productReferences,
      sortField: mapSearchSortTypeByOrdinal(sortField),
      sortDirection,
      orderType: mapListOrderType(orderType),
    };

    return this.http.post(`${this.epicuroBaseUrl}/export/mdo`, body, {
      responseType: 'blob',
      observe: 'response',
    });
  }

  public exportToImages({
    accountIds,
    productReferences,
  }: ProductListExportToImageRequest): Observable<HttpResponse<Blob>> {
    const body = {
      accountIds,
      productReferences,
      orderType: ListOrderType.Any,
      includeImages: true,
      includeExcel: false,
    };

    return this.http.post(`${this.epicuroBaseUrl}/export/mdo`, body, {
      responseType: 'blob',
      observe: 'response',
    });
  }
}
